import { getViewStateById } from '../selectors/collabSpaceSelectors';
import { AccessIssue, getCombinedAccessIssue } from 'owa-attachment-policy-access-issue-checker';

export function showErrorInfo(viewStateId: string) {
    const viewState = getViewStateById(viewStateId);
    return hasAccessIssue() || viewState?.fluidLinkFailed || viewState?.meetingsFolderAccessFailed;
}

export function hasAccessIssue() {
    const accessIssue: AccessIssue = getCombinedAccessIssue();
    return accessIssue !== AccessIssue.None;
}
